import api from './client';

export const strategiesApi = {
  // CRUD
  list: () => api.get('/strategies'),
  get: (id: string) => api.get(`/strategies/${id}`),
  create: (data: {
    name: string;
    strategyType: string;
    description?: string;
    grantorId?: string;
    entityId?: string;
    targetAssetId?: string;
    parameters: any;
  }) => api.post('/strategies', data),
  update: (id: string, data: any) => api.put(`/strategies/${id}`, data),
  delete: (id: string) => api.delete(`/strategies/${id}`),

  // Status
  updateStatus: (id: string, status: string) =>
    api.patch(`/strategies/${id}/status`, { status }),

  // Calculate (preview without saving)
  calculate: (strategyType: string, parameters: any) =>
    api.post('/strategies/calculate', { strategyType, parameters }),

  // Combination engine
  runCombination: (strategyIds: string[]) =>
    api.post('/strategies/combination', { strategyIds }),
  saveCombination: (data: { name: string; description?: string; strategyIds: string[] }) =>
    api.post('/strategies/combination/save', data),
  listCombinations: () => api.get('/strategies/combinations/list'),

  // Summary
  summary: () => api.get('/strategies/summary/overview'),

  // Gifting optimizer
  giftingOptimizer: (params: { numDonees?: number; years?: number; includeSpouseSplitting?: boolean }) =>
    api.post('/strategies/gifting-optimizer', params),
};
